import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HeaderNavigation } from '@/components/HeaderNavigation'
import type { StickyHeaderNavigationProps } from './types'
import useOffsets from '@/hooks/useOffsets'
import { Close } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'

/**
 * Компонент фиксированной навигации с липким позиционированием
 * Заменяет повторяющийся код с data-component="currency-details-header-container"
 */
export const StickyHeaderNavigation: React.FC<StickyHeaderNavigationProps> = ({
  showBackButton = true,
  title,
  rightIcon,
  marginHorizontal = 0,
  onBackPress,
  onMoreOptionsPress,
  showBackground = true,
  containerStyle = {},
  showExitButton = false,
  exitButtonStyle = {},
  exitNavigateTo = '/dashboard',
  onExitPress,
}) => {
  const navigate = useNavigate()
  const offsets = useOffsets()
  const theme = useTheme()

  const defaultStyle: React.CSSProperties = {
    position: 'fixed',
    width: '100%',
    top: 0,
    paddingTop: offsets.top,
    zIndex: 1000,
    ...(showBackground && { backgroundColor: '#131415' }),
    ...containerStyle,
  }

  const handleExitPress = () => {
    if (onExitPress) {
      onExitPress()
    } else {
      navigate(exitNavigateTo)
    }
  }
  const exitButton = showExitButton ? (
    <button
      onClick={handleExitPress}
      style={{
        padding: '4px',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...exitButtonStyle,
      }}
    >
      <Close size={28} color={theme.colors.label.default} />
    </button>
  ) : null

  return (
    <div
      data-component="sticky-header-navigation"
      style={{
        ...defaultStyle,
      }}
    >
      <HeaderNavigation
        showBackButton={showBackButton}
        title={title}
        rightIcon={showExitButton ? exitButton : rightIcon}
        marginHorizontal={marginHorizontal}
        onBackPress={onBackPress}
        onMoreOptionsPress={onMoreOptionsPress}
      />
    </div>
  )
}
